import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <h1>This is the about page</h1>
      <p>Appis to serach GitHub users</p>
    </Fragment>
  );
};

export default About;
